// Sound utility functions for the application

let vibratingSound = null;
let ringingSound = null;

/**
 * Play the vibrating sound effect
 * @param {boolean} enabled - Whether sound effects are enabled
 * @param {boolean} isOffline - Whether the environment is offline
 */
export const playVibratingSound = (enabled = true, isOffline = false) => {
  if (!enabled || isOffline) {
    if (isOffline) console.log('🔇 Vibrating sound suppressed (offline)');
    return;
  }
  
  try {
    // Stop any currently playing vibrating sound
    if (vibratingSound) {
      vibratingSound.pause();
      vibratingSound.currentTime = 0;
    }

    // Create new audio instance
    vibratingSound = new Audio('/sounds/vibrating.mp3');
    vibratingSound.volume = 0.5; // Set moderate volume
    
    // Play the sound
    const playPromise = vibratingSound.play();
    
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        console.warn('Failed to play vibrating sound:', error);
      });
    }
  } catch (error) {
    console.warn('Error creating or playing vibrating sound:', error);
  }
};

/**
 * Stop the vibrating sound if it's currently playing
 */
export const stopVibratingSound = () => {
  try {
    if (vibratingSound) {
      vibratingSound.pause();
      vibratingSound.currentTime = 0;
    }
  } catch (error) {
    console.warn('Error stopping vibrating sound:', error);
  }
};

/**
 * Play the ringing sound effect for incoming calls
 * @param {boolean} enabled - Whether sound effects are enabled
 * @param {boolean} isOffline - Whether the environment is offline
 */
export const playRingingSound = (enabled = true, isOffline = false) => {
  if (!enabled || isOffline) {
    if (isOffline) console.log('🔇 Ringing sound suppressed (offline)');
    return;
  }
  
  try {
    // Stop any currently playing ringing sound
    if (ringingSound) {
      ringingSound.pause();
      ringingSound.currentTime = 0;
    }

    // Create new audio instance
    ringingSound = new Audio('/sounds/ringing.mp3');
    ringingSound.volume = 0.7; // Set slightly higher volume for ringing
    ringingSound.loop = true; // Loop the ringing sound until stopped
    
    // Play the sound
    const playPromise = ringingSound.play();
    
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        console.warn('Failed to play ringing sound:', error);
      });
    }
  } catch (error) {
    console.warn('Error creating or playing ringing sound:', error);
  }
};

/**
 * Stop the ringing sound if it's currently playing
 */
export const stopRingingSound = () => {
  try {
    if (ringingSound) {
      ringingSound.pause();
      ringingSound.currentTime = 0;
    }
  } catch (error) {
    console.warn('Error stopping ringing sound:', error);
  }
};

/**
 * Play the outbound ringing sound effect for outgoing calls
 * @param {boolean} enabled - Whether sound effects are enabled
 * @param {boolean} isOffline - Whether the environment is offline
 */
export const playRingingOutSound = (enabled = true, isOffline = false) => {
  if (!enabled || isOffline) {
    if (isOffline) console.log('🔇 Outbound ringing sound suppressed (offline)');
    return;
  }
  
  try {
    // Stop any currently playing ringing sound
    if (ringingSound) {
      ringingSound.pause();
      ringingSound.currentTime = 0;
    }

    // Create new audio instance
    ringingSound = new Audio('/sounds/ringing-out.mp3');
    ringingSound.volume = 0.7; // Set slightly higher volume for ringing
    ringingSound.loop = true; // Loop the ringing sound until stopped
    
    // Play the sound
    const playPromise = ringingSound.play();
    
    if (playPromise !== undefined) {
      playPromise.catch(error => {
        console.warn('Failed to play outbound ringing sound:', error);
      });
    }
  } catch (error) {
    console.warn('Error creating or playing outbound ringing sound:', error);
  }
};

/**
 * Check if vibrating sound is currently playing
 */
export const isVibratingPlaying = () => {
  return vibratingSound && !vibratingSound.paused;
};

/**
 * Check if ringing sound is currently playing
 */
export const isRingingPlaying = () => {
  return ringingSound && !ringingSound.paused;
};
